import { render, staticRenderFns } from "./produceClues.vue?vue&type=template&id=58704ce6&scoped=true&lang=html&"
import script from "./produceClues.vue?vue&type=script&lang=js&"
export * from "./produceClues.vue?vue&type=script&lang=js&"
import style0 from "./produceClues.vue?vue&type=style&index=0&id=58704ce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58704ce6",
  null
  
)

component.options.__file = "produceClues.vue"
export default component.exports